import {
    IProductsTaxItem,
} from "@/entity/warehouse/Products/Tax/Tax.types"

export default class ProductsTaxTypes implements IProductsTaxItem {
    id: number | null
    name: string
    default: boolean
    value: string
    constructor(data: IProductsTaxItem) {
        this.id = data.id
        this.name = data.name
        this.default = data.default
        this.value = data.value
    }
}